import * as React from 'react'
import { useInsightById } from '@renderer/windows/features/home/hooks/use-insights'
import { ArtifactPreviewLoading } from './artifact-preview-loading'
import { ArtifactTimestamp } from './artifact-timestamp'

interface HighlightPreviewProps {
  highlightId: string
}

export function HighlightPreview({ highlightId }: HighlightPreviewProps) {
  const { data: highlight, isLoading, error } = useInsightById(highlightId)

  React.useEffect(() => {
    console.log('[HighlightPreview] Loading highlight:', {
      highlightId,
      isLoading,
      hasData: !!highlight,
      hasError: !!error,
      error: error?.message,
    })
  }, [highlightId, isLoading, highlight, error])

  if (isLoading) {
    return <ArtifactPreviewLoading />
  }

  if (error || !highlight) {
    return (
      <div className="text-light/40">
        <p className="text-sm">Failed to load highlight</p>
        {error && <p className="mt-1 text-xs">ID: {highlightId}</p>}
      </div>
    )
  }

  return (
    <div className="max-h-48 max-w-64 space-y-2 text-[13px]">
      <div className="flex flex-col gap-0.5 font-normal">
        <p className="text-light/80 truncate font-medium">Highlight</p>
        <p className="text-light/40 text-xs">
          <ArtifactTimestamp date={highlight.createdAt} />
        </p>
      </div>

      <div className="text-light/60 flex flex-col gap-1 text-ellipsis whitespace-pre-line leading-normal">
        {highlight.insight}
      </div>
    </div>
  )
}
